import React from 'react';
import './HeaderComponents.css';
import { Avatar } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser } from './features/userSlice';

function HeaderComponents({ avatar, Icon, title, onClick}) {
  const user = useSelector(selectUser);
  
  return (
    <div onClick={onClick} className='headerOption'>
      {Icon && <Icon className='headerOption_icon'/>}
      {avatar && <Avatar src={user!==null && user.photoUrl!==null ? user.photoUrl : ""} 
      className='headerOption_icon'>
        {user!==null && user.displayName!==null ? user.displayName[0] : "" } </Avatar>}
      <h3 className='headerOption_title'>{title}</h3>
    </div>
  )
}

export default HeaderComponents